import PreviousMeasurements from 'local/components/PreviousMeasurements';
import 'local/components/SupportForm';
import 'local/components/AdvancedSettings';
import 'a11y-toggle';
import '@internetstiftelsen/styleguide/dist/molecules/modal/modal';
import '@internetstiftelsen/styleguide/dist/molecules/alert/alert';
import '@internetstiftelsen/styleguide/dist/focusTrap';
import '@internetstiftelsen/styleguide/dist/organisms/accordion/accordion';
import '@internetstiftelsen/styleguide/dist/assets/js/iconToggle';
import '@internetstiftelsen/styleguide/dist/molecules/context-menu/context-menu';

/**
 * Main entry point for the javascript bundle.
 */
console.log('🎉 Bredbandskollen is up and running!');

PreviousMeasurements.fetch();

if (document.getElementById('measure')) {
	import('./measure').then(() => {
		console.log('🎉 Measurement button loaded!');
	});
}

if (document.getElementById('map')) {
	import(/* webpackChunkName: "heatmap" */ './components/Map')
		.then(() => {
			console.log('🎉 Map loaded!');
		})
		.catch((err) => {
			console.log('Failed to load heatmap', err);
		});
}

if (document.getElementById('map_canvas')) {
	import(/* webpackChunkName: "heatmap" */ './heatmap/index')
		.then(({ default: Heatmap }) => {
			Heatmap.initialize();
		})
		.catch((err) => {
			console.log('Failed to load heatmap', err);
		});
}
